/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const Plus2Icon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 10.75H13.25V5C13.25 4.66848 13.1183 4.35054 12.8839 4.11612C12.6495 3.8817 12.3315 3.75 12 3.75C11.6685 3.75 11.3505 3.8817 11.1161 4.11612C10.8817 4.35054 10.75 4.66848 10.75 5V10.75H5C4.66848 10.75 4.35054 10.8817 4.11612 11.1161C3.8817 11.3505 3.75 11.6685 3.75 12C3.75 12.3315 3.8817 12.6495 4.11612 12.8839C4.35054 13.1183 4.66848 13.25 5 13.25H10.75V19C10.75 19.3315 10.8817 19.6495 11.1161 19.8839C11.3505 20.1183 11.6685 20.25 12 20.25C12.3315 20.25 12.6495 20.1183 12.8839 19.8839C13.1183 19.6495 13.25 19.3315 13.25 19V13.25H19C19.3315 13.25 19.6495 13.1183 19.8839 12.8839C20.1183 12.6495 20.25 12.3315 20.25 12C20.25 11.6685 20.1183 11.3505 19.8839 11.1161C19.6495 10.8817 19.3315 10.75 19 10.75Z"
        fill="#F6FAFD"
        stroke="#F6FAFD"
        strokeWidth="0.5"
      />
    </svg>
  )
}
